"use strict";

module.exports = require("./is-implemented")()
	? Object.assign
	: require("./shim");



// WEBPACK FOOTER //
// ./node_modules/event-emitter/node_modules/es5-ext/object/assign/index.js